import { Col, Row } from 'antd';
import React, { useCallback, useRef, useState } from 'react';
import Flex from '../Flex';
import FoldingRow from './FoldingRow';

export interface FoldingPanelAttr {
  title: string | React.ReactElement;
  value: string | React.ReactElement;
}

export interface FoldingListItem {
  title: string | React.ReactElement;
  description: string | React.ReactElement;
  attrs: { [key: string]: FoldingPanelAttr };
}

export interface FoldingPanelProps extends FoldingListItem {
}

export default function FoldingPanel(props: FoldingPanelProps) {

  const [open, setOpen] = useState(false);
  const handleChangeOpen = useCallback(() => setOpen(x => !x), [setOpen]);

  const downPanelRef = useRef<HTMLDivElement>();

  return (
    <Flex gap={0} direction="column">
      <FoldingRow open={open} onClick={handleChangeOpen} {...props} />
      <div
        ref={downPanelRef}
        style={{ maxHeight: open ? `${downPanelRef?.current?.scrollHeight}px` : 0 }}
        className="w-[100%] bg-zinc-100 mx-auto overflow-hidden transition-all duration-300 ease-in-out"
      >
        <Flex direction="column" className=" text-sm p-2 shadow-sm">
          <Row gutter={[8, 8]}>
            {Object.keys(props?.attrs ?? {}).map((key, index) => {
              // if (props?.details?.[key].title === '' || props?.details?.[key].title == null) return <></>;
              return (
                <Col key={index} span={12}>
                  <Flex gap={4} direction="column" style={{
                    borderRadius: '.062rem',
                    borderBottom: '.031rem dashed rgb(115, 115, 115)',
                    height: '100%'
                  }}>
                    <Flex gap={4} align="center" className="relative text-xs text-neutral-500">
                      <div className="w-[4px] h-[4px] bg-neutral-400 rounded-full" style={{ width: 5, height: 5 }} />
                      {props?.attrs?.[key].title}
                    </Flex>
                    <div className="pb-2">
                      <b>{props?.attrs?.[key].value ?? ' '}</b>
                    </div>
                  </Flex>
                </Col>
              );
            })}
          </Row>
        </Flex>
      </div>
    </Flex>
  );
}
